/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Library_Example_BriefInputs */

const en_mcp_cap_library_example_brief = /** @type {(inputs: Mcp_Cap_Library_Example_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product brief`)
};

const es_mcp_cap_library_example_brief = /** @type {(inputs: Mcp_Cap_Library_Example_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen del producto`)
};

/**
* | output |
* | --- |
* | "Product brief" |
*
* @param {Mcp_Cap_Library_Example_BriefInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_library_example_brief = /** @type {((inputs?: Mcp_Cap_Library_Example_BriefInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Library_Example_BriefInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_library_example_brief(inputs)
	return en_mcp_cap_library_example_brief(inputs)
});